module.exports = __webpack_public_path__ + "media/images/shorts-linkedin-668c8ee5144f91a77c1fe2457e1b704b.svg";